import styled from 'styled-components';

export const Container = styled.div`
  .inputsearch input {
    text-transform: uppercase;
    &::placeholder{
      color: #6c6c6c;
      text-transform: uppercase;
    }
  }
`;

export const HeadSection = styled.div`
  display: flex;
  flex-direction: 'column';
`;

export const Label = styled.div`
  color: #610082;
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
`;

export const BodySection = styled.div`
  height: 200px;
`;

export const CollapsibleListWrapper = styled.div`
  margin-bottom: 3px;
`;

export const ErrorSection = styled.div`
`;
